import * as React from 'react';
import PropTypes from 'prop-types';
import { SidebarNext } from './SidebarNextNext';

// FIXME: move to TS, don't reexport SidebarNext
export default SidebarNext;
